//painel-admin/src/pages/TikpagBIImobiliaria.jsx

import React, { useEffect, useMemo, useState } from "react";
import axios from "../axiosConfig";
import { Link, useParams } from "react-router-dom";
import {
  ArrowLeft,
  BarChart3,
  Building2,
  CalendarDays,
  RefreshCcw,
  TrendingUp
} from "lucide-react";

import "./TikpagBIImobiliaria.css";

function TikpagBIImobiliaria() {
  const { cnpj } = useParams();

  const hoje = new Date();
  const dataFimPadrao = hoje.toISOString().slice(0, 10);
  const dataInicioPadrao = new Date(hoje.getTime() - 30 * 24 * 60 * 60 * 1000)
    .toISOString()
    .slice(0, 10);

  const [dados, setDados] = useState(null);
  const [mensagem, setMensagem] = useState("");
  const [loading, setLoading] = useState(false);

  const [filtros, setFiltros] = useState({
    inicio: dataInicioPadrao,
    fim: dataFimPadrao,
    status: ""
  });

  const [mesSelecionado, setMesSelecionado] = useState(null);

  const carregarDetalhe = async () => {
    setLoading(true);
    setMensagem("");

    try {
      const params = new URLSearchParams();

      if (filtros.inicio) params.append("inicio", filtros.inicio);
      if (filtros.fim) params.append("fim", filtros.fim);
      if (filtros.status) params.append("status", filtros.status);

      const { data } = await axios.get(
        `/admin/tikpag-bi/imobiliaria/${cnpj}?${params.toString()}`
      );

      setDados(data);
    } catch (err) {
      setMensagem(
        err.response?.data?.error ||
          "Não foi possível carregar os dados da imobiliária."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarDetalhe();
    // eslint-disable-next-line
  }, [cnpj]);

  const formatarMoeda = (valor) => {
    return Number(valor || 0).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL"
    });
  };

  const formatarNumero = (valor) => {
    return Number(valor || 0).toLocaleString("pt-BR");
  };

  const formatarPercentual = (valor) => {
    return `${Number(valor || 0).toLocaleString("pt-BR", {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    })}%`;
  };

  const formatarData = (valor) => {
    if (!valor) return "-";

    try {
      return new Date(valor).toLocaleString("pt-BR");
    } catch {
      return "-";
    }
  };

  const evolucaoNormalizada = useMemo(() => {
    const lista = dados?.evolucao || [];
    const maior = Math.max(
      ...lista.map((item) => Number(item.volume_aprovado || 0)),
      1
    );

    return lista.map((item) => ({
        ...item,
        altura: Math.max(
          8,
          (Number(item.volume_aprovado || 0) / maior) * 100
        )
      }));
    }, [dados]);


      useEffect(() => {
      if (!evolucaoNormalizada.length) {
        setMesSelecionado(null);
        return;
      }

      setMesSelecionado((atual) => {
        const aindaExiste = evolucaoNormalizada.find((item) => item.mes === atual?.mes);
        return aindaExiste || evolucaoNormalizada[evolucaoNormalizada.length - 1];
      });
    }, [evolucaoNormalizada]);


  const aplicarFiltros = (e) => {
    e.preventDefault();
    carregarDetalhe();
  };

  const formatarMes = (mes) => {
  if (!mes) return "-";

  const [ano, numeroMes] = String(mes).split("-");
  const nomes = [
    "Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
    "Jul", "Ago", "Set", "Out", "Nov", "Dez"
  ];

  return `${nomes[Number(numeroMes) - 1]}/${String(ano).slice(2)}`;
};

  return (
    <div className="tikpagBIImob-page">
      <header className="tikpagBIImob-header">
        <div>
          <Link to="/admin/tikpag-bi" className="tikpagBIImob-back">
            <ArrowLeft size={16} />
            Voltar para BI
          </Link>

          <span className="tikpagBIImob-kicker">Detalhe da imobiliária</span>

          <h1>{dados?.empresa?.imobiliaria || "Carregando..."}</h1>

          <p>
            CNPJ: <strong>{dados?.empresa?.imobiliaria_cnpj || cnpj}</strong>
          </p>
        </div>

        <button
          type="button"
          onClick={carregarDetalhe}
          disabled={loading}
          className="tikpagBIImob-refresh"
        >
          <RefreshCcw
            size={16}
            className={loading ? "tikpagBIImob-spin" : ""}
          />
          Atualizar
        </button>
      </header>

      {mensagem && (
        <div className="tikpagBIImob-alert">
          {mensagem}
        </div>
      )}

      <section className="tikpagBIImob-card tikpagBIImob-filterCard">
        <form onSubmit={aplicarFiltros} className="tikpagBIImob-filters">
          <label>
            <span>Data inicial</span>
            <input
              type="date"
              value={filtros.inicio}
              onChange={(e) =>
                setFiltros((prev) => ({ ...prev, inicio: e.target.value }))
              }
            />
          </label>

          <label>
            <span>Data final</span>
            <input
              type="date"
              value={filtros.fim}
              onChange={(e) =>
                setFiltros((prev) => ({ ...prev, fim: e.target.value }))
              }
            />
          </label>

          <label>
            <span>Status</span>
            <select
              value={filtros.status}
              onChange={(e) =>
                setFiltros((prev) => ({ ...prev, status: e.target.value }))
              }
            >
              <option value="">Todos</option>
              <option value="Aprovado">Aprovado</option>
              <option value="Negado">Negado</option>
              <option value="Aguardando autenticação do cliente">
                Aguardando autenticação
              </option>
              <option value="Cancelado">Cancelado</option>
            </select>
          </label>

          <button type="submit" disabled={loading}>
            <CalendarDays size={16} />
            Aplicar filtros
          </button>
        </form>
      </section>

      <section className="tikpagBIImob-cards">
        <div className="tikpagBIImob-metric">
          <div className="tikpagBIImob-icon">
            <Building2 size={21} />
          </div>

          <span>Total de operações</span>
          <strong>{formatarNumero(dados?.cards?.total_operacoes)}</strong>
          <small>No período filtrado</small>
        </div>

        <div className="tikpagBIImob-metric">
          <div className="tikpagBIImob-icon">
            <TrendingUp size={21} />
          </div>

          <span>Volume aprovado</span>
          <strong>{formatarMoeda(dados?.cards?.volume_aprovado)}</strong>
          <small>{formatarNumero(dados?.cards?.total_aprovadas)} aprovadas</small>
        </div>

        <div className="tikpagBIImob-metric">
          <div className="tikpagBIImob-icon">
            <BarChart3 size={21} />
          </div>

          <span>Ticket médio</span>
          <strong>{formatarMoeda(dados?.cards?.ticket_medio_aprovado)}</strong>
          <small>Somente operações aprovadas</small>
        </div>

        <div className="tikpagBIImob-metric risco">
          <div className="tikpagBIImob-icon">
            <RefreshCcw size={21} />
          </div>

          <span>Taxa de aprovação</span>
          <strong>{formatarPercentual(dados?.cards?.taxa_aprovacao)}</strong>
          <small>{formatarNumero(dados?.cards?.total_negadas)} negadas</small>
        </div>
      </section>

      <section className="tikpagBIImob-monthCards">
        <div className="tikpagBIImob-monthCard destaque">
          <span>Volume mês atual</span>
          <strong>{formatarMoeda(dados?.comparativo_mensal?.volume_mes_atual)}</strong>
          <small>
            {formatarNumero(dados?.comparativo_mensal?.operacoes_mes_atual)} operações aprovadas
          </small>
        </div>

        <div className="tikpagBIImob-monthCard">
          <span>Volume mês anterior</span>
          <strong>{formatarMoeda(dados?.comparativo_mensal?.volume_mes_anterior)}</strong>
          <small>
            {formatarNumero(dados?.comparativo_mensal?.operacoes_mes_anterior)} operações aprovadas
          </small>
        </div>

        <div className="tikpagBIImob-monthCard variacao">
          <span>Variação mensal</span>
          <strong>{formatarPercentual(dados?.comparativo_mensal?.variacao_percentual)}</strong>
          <small>Comparativo mês atual vs anterior</small>
        </div>
      </section>

      <section className="tikpagBIImob-grid">
        <div className="tikpagBIImob-card">
          <div className="tikpagBIImob-sectionHeader">
            <h2>Evolução mensal</h2>
            <p>Volume aprovado mês a mês no período selecionado.</p>
          </div>

            <div className="tikpagBIImob-chartContent">
              <div className="tikpagBIImob-chart">
                {evolucaoNormalizada.length === 0 ? (
                  <div className="tikpagBIImob-empty">
                    Nenhum dado para o período.
                  </div>
                ) : (
                  evolucaoNormalizada.map((item) => (
                    <button
                      type="button"
                      className={`tikpagBIImob-barItem ${
                        mesSelecionado?.mes === item.mes ? "ativo" : ""
                      }`}
                      key={item.mes}
                      onMouseEnter={() => setMesSelecionado(item)}
                      onFocus={() => setMesSelecionado(item)}
                      onClick={() => setMesSelecionado(item)}
                    >
                      <div className="tikpagBIImob-barTrack">
                        <div
                          className="tikpagBIImob-bar"
                          style={{ height: `${item.altura}%` }}
                        />
                      </div>

                      <small>{formatarMes(item.mes)}</small>
                    </button>
                  ))
                )}
              </div>

              <aside className="tikpagBIImob-monthInsight">
                <span>Mês selecionado</span>

                <strong>
                  {mesSelecionado ? formatarMes(mesSelecionado.mes) : "-"}
                </strong>

                <div>
                  <small>Volume aprovado</small>
                  <b>{formatarMoeda(mesSelecionado?.volume_aprovado)}</b>
                </div>

                <div>
                  <small>Operações aprovadas</small>
                  <b>{formatarNumero(mesSelecionado?.aprovadas)}</b>
                </div>

                <div>
                  <small>Total de operações</small>
                  <b>{formatarNumero(mesSelecionado?.total_operacoes)}</b>
                </div>
              </aside>
            </div>

        </div>

        <div className="tikpagBIImob-card">
          <div className="tikpagBIImob-sectionHeader">
            <h2>Resumo por status</h2>
            <p>Distribuição das operações da imobiliária.</p>
          </div>

          <div className="tikpagBIImob-statusList">
            {(dados?.por_status || []).map((item) => (
              <div className="tikpagBIImob-statusItem" key={item.status}>
                <div>
                  <strong>{item.status || "Sem status"}</strong>
                  <span>{formatarNumero(item.total)} operações</span>
                </div>

                <b>{formatarMoeda(item.volume_total)}</b>
              </div>
            ))}

            {!dados?.por_status?.length && (
              <div className="tikpagBIImob-empty">
                Nenhum status encontrado.
              </div>
            )}
          </div>
        </div>
      </section>

      <section className="tikpagBIImob-card">
        <div className="tikpagBIImob-sectionHeader">
          <h2>Últimas operações</h2>
          <p>Até 300 registros mais recentes dentro dos filtros selecionados.</p>
        </div>

        <div className="tikpagBIImob-tableWrap">
          <table className="tikpagBIImob-table">
            <thead>
              <tr>
                <th>Pedido</th>
                <th>Data</th>
                <th>Cliente</th>
                <th>Status</th>
                <th>Parcelas</th>
                <th>Valor</th>
              </tr>
            </thead>

            <tbody>
              {(dados?.operacoes || []).map((op) => (
                <tr key={op.tikpag_id}>
                  <td>#{op.tikpag_id}</td>
                  <td>{formatarData(op.data_criacao)}</td>
                  <td>{op.cliente || "-"}</td>
                  <td>
                    <span className={`tikpagBIImob-statusPill ${String(op.status || "").toLowerCase().replace(/\s+/g, "-")}`}>
                      {op.status || "-"}
                    </span>
                  </td>
                  <td>{op.parcelas}x</td>
                  <td>
                    <strong>{formatarMoeda(op.valor)}</strong>
                  </td>
                </tr>
              ))}

              {!dados?.operacoes?.length && (
                <tr>
                  <td colSpan="6">Nenhuma operação encontrada.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}

export default TikpagBIImobiliaria;